export default{breadcrumb:"w_A",item:"w_B",separator:"w_C"};
